import { render, staticRenderFns } from "./communitySpacePersonManageList.vue?vue&type=template&id=a63e4bc2&scoped=true"
import script from "./communitySpacePersonManageList.vue?vue&type=script&lang=js"
export * from "./communitySpacePersonManageList.vue?vue&type=script&lang=js"
import style0 from "./communitySpacePersonManageList.vue?vue&type=style&index=0&id=a63e4bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63e4bc2",
  null
  
)

export default component.exports